define('apps/admin/views/strong-validation',[
    'njs!apps/admin/templates/includes/_strong_validation(params:tmpl=admin/main/includes/_strong_validation.html)',
], function(template) {
    'use strict';

    return Mn.ItemView.extend({

        "template": template,

        "tagName": "div",

        "change": "render"

    });
});

